module.exports = __webpack_public_path__ + "img/laoban.jpg";